import { render, staticRenderFns } from "./DailyParagraph.vue?vue&type=template&id=6fd442e4&scoped=true&"
import script from "./DailyParagraph.vue?vue&type=script&lang=js&"
export * from "./DailyParagraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd442e4",
  null
  
)

export default component.exports